import { useMutation } from '@tanstack/react-query';

import { encodeRequestBody } from '~/utils/encodeRequestBody';
import { requestWithTimeout } from '~/utils/requestWithTimeout';
import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

type Input = { sql: string; parameters?: Record<string, unknown> };
type Estimate = { bytesProcessed: number; estimatedUsd: number; usdPerTiB: number };

export function estimateLensScan(input: Input) {
  return requestWithTimeout<Estimate>(
    resolveReportingLeLensUrl('/api/reporting/le-lenses/scan-cost'),
    { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(encodeRequestBody(input)) },
    'The scan check is taking longer than expected. Try again.',
  );
}

export function useLensScanCost() {
  return useMutation({ mutationFn: estimateLensScan, retry: false });
}
